import { render, staticRenderFns } from "./OMTablePagination.vue?vue&type=template&id=1a564dca&scoped=true"
import script from "./OMTablePagination.vue?vue&type=script&lang=js"
export * from "./OMTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../omniscient/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a564dca",
  null
  
)

export default component.exports